import { ErrorHandler, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AngularPlugin } from '@microsoft/applicationinsights-angularplugin-js';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class InsightsService {
    private angularPlugin = new AngularPlugin();
    private appInsights: ApplicationInsights;

    constructor(private router: Router) {
        this.appInsights = new ApplicationInsights({
          config: {
              connectionString: environment.appInsights.connectionString,
              extensions: [this.angularPlugin],
              extensionConfig: {
                  [this.angularPlugin.identifier]: {
                      router: this.router,
                      errorServices: [new ErrorHandler()],
                  },
              },
          },
      });
        this.appInsights.loadAppInsights();
    }

    // expose methods that can be used in components and services
    trackEvent(name: string, properties?: { [key: string]: any }): void {
        this.appInsights.trackEvent({
            name: name,
            properties: {
              ...properties,
              environment: environment.environmentLabel
            }
           }
        );
    }

    trackPageView(name: string, uri: string, properties?: { [key: string]: any }): void {
      this.appInsights.trackPageView({
          name: name,
          uri: uri,
          properties: {
            ...properties,
            environment: environment.environmentLabel
          }
       });
    }

    trackTrace(message: string, properties?: { [key: string]: any }): void {
        this.appInsights.trackTrace({
          message,
          properties: {
            ...properties,
            environment: environment.environmentLabel
          }
        });
    }
}
